/*jshint esversion:6 */
import React from "react";
import { Permissioned } from "react-permissions";
import { connect } from "react-redux";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import TransactionAPI from "../../../api/TransactionsApi";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Permissions from "../../../configurations/permissions";
import NewClaimTxnFilter from "./newClaimTxnFilter";
import NewClaimTxnTable from "./newClaimTxnTable";
import NewClaimModal from "./newClaimModal";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import Constants from "../../../configurations/constants";

class NewClaimPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tableData: [],
      selectedTransaction: null,
      loading: false,
      pageNum: 0,
      pageSize: 0,
      pages: 0
    };
    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.onTransactionRowClick = this.onTransactionRowClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.paginateid = this.paginateid.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
  }

  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    //const idx = parseInt(index, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
  }

  onSearchHandler(txnType, channel, params) {
    this.setState({ loading: true, tableData: [] });

    TransactionAPI.findTransactions(txnType, channel, params)
      .then(response => {
        let data = response.data;
        data = data.map(d => {
          return {
            ...d,
            transactionDate: Util.toUserLocalTime(d.transactionDate)
          };
        });
        //augment the code to pad for ID
        //Set a fake length count
        this.setState({
          pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
          pages: Constants.PAGINATION_OFFSET_INDEX - 1,
          pageNum: Constants.PAGINATION_OFFSET_INDEX - 1
        });

        let totalCount = data.length;

        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;

        if (data.length === 0)
          Toaster.warning("No records found.", "Transactions");

        this.setState({ tableData: data, loading: false, pages: pages });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_TRANSACTIONS_SEARCH}`
        ]);
        this.setState({ loading: false });
      });
  }
  onTransactionRowClick(index) {
    this.setState({ selectedTransaction: this.state.tableData[index] });
  }
  handleCloseModal() {
    this.setState({ selectedTransaction: null });
  }

  render() {
    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Search Transactions" />
        <NewClaimTxnFilter onSearchHandler={this.onSearchHandler} />
        <Divider />
        <NewClaimTxnTable
          onRowClick={this.onTransactionRowClick}
          tableData={this.state.tableData}
          loading={this.state.loading}
          paginatedCallback={this.paginateid}
          page={this.state.pageNum}
          pages={this.state.pages}
          onTableChange={this.onTableChange}
        />
        {this.state.selectedTransaction && (
          <NewClaimModal
            onRequestClose={this.handleCloseModal}
            isOpen={this.state.selectedTransaction != null}
            transaction={this.state.selectedTransaction}
          />
        )}
      </div>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(NewClaimPage, [Permissions.CREATE_DISPUTE])
);



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/newClaim/newClaimPage.js